// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__hxYMJ"};